import React from 'react'
import {MailMagazine} from '../../../DTO/MailMagazineDTO'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'

type Props = {
  title: string
  mailMagazineIdCheckedList: number[]
  mailMagazineList: MailMagazine[]
}

export function MailMagazineConfirmContentBlock(props: Props): JSX.Element {
  if (props.mailMagazineList.length === 0) {
    return <></>
  }

  const selectedMailMagazineNames = props.mailMagazineList
    .filter((item) => props.mailMagazineIdCheckedList.includes(item.id))

  return (
    <>
      <ContentBlock data-testid={'block-mail-magazine'}>
        <ContentTitle>{props.title}</ContentTitle>
        {
          selectedMailMagazineNames.length === 0
            ? <p className="">メルマガのご希望はありません</p>
            : <ul className="list-disc_01 fts15">
              {selectedMailMagazineNames.map(
                item => <li key={item.id}>{item.name}</li>,
              )}
            </ul>
        }
      </ContentBlock>
    </>
  )
}
